module.exports = __webpack_public_path__ + "static/img/16.a1bf5b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/16.png
// module id = YJ5c
// module chunks = 1